import { render, staticRenderFns } from "./InvoiceReports.vue?vue&type=template&id=4961a326"
import script from "./InvoiceReports.vue?vue&type=script&lang=js"
export * from "./InvoiceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports